'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  isRequesting: false,
  isRequestingSearch: false,
  isRequestingTrackById: false,
  isRequestingPartner: false,
  hasError: false,
  recentError: undefined,
  lastValidResult: 0,
  totalCount: 0,
  tracksById: ImmutableMap()
});
export default function Tracks(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.TRACKS_REQUESTING:
      return state.merge({
        hasError: false,
        isRequesting: !action.meta.isPartner ? true : state.get('isRequesting'),
        isRequestingPartner: action.meta.isPartner ? true : state.get('isRequestingPartner')
      });
    case ActionTypes.TRACKS_BY_ID_RECEIVED:
      return state.mergeDeep({
        isRequesting: !action.meta.isPartner ? false : state.get('isRequesting'),
        isRequestingPartner: action.meta.isPartner ? false : state.get('isRequestingPartner'),
        hasError: false,
        lastValidResult: action.meta.timestamp,
        tracksById: action.payload.tracksById
      });
    case ActionTypes.TRACKS_ERROR:
      return state.merge({
        hasError: true,
        isRequesting: false,
        recentError: action.payload
      });
    case ActionTypes.TRACK_BY_ID_REQUESTING:
      return state.mergeDeep({
        isRequestingTrackById: true,
        tracksById: {
          [action.meta.id]: state.getIn(['tracksById', action.meta.id], ImmutableMap()).merge({
            isRequesting: true,
            hasError: false
          })
        }
      });
    case ActionTypes.TRACK_BY_ID_RECEIVE:
      {
        const trackId = action.payload.tracksById.keySeq().first();
        return state.merge({
          isRequestingTrackById: false
        }).mergeIn(['tracksById', trackId], action.payload.tracksById.get(trackId).set('lastValidResult', Date.now()));
      }
    case ActionTypes.TRACK_BY_ID_ERROR:
      return state.mergeDeep({
        isRequestingTrackById: false,
        tracksById: {
          [action.meta.id]: ImmutableMap({
            isRequesting: false,
            hasError: true,
            recentError: action.payload
          })
        }
      });
    default:
      return state;
  }
}